var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhysiciansResearchManagement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 88 88",
    enableBackground: "new 0 0 88 88",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000182486857897813883040000002949417202998998913_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    points: "52.5,24.2 8.9,24.2 8.9,73.7  57.6,73.7 57.6,47.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#E1D159",
    strokeWidth: 0.45,
    strokeMiterlimit: 10,
    points: "51.2,26 10.6,26 10.6,72 54.7,72  54.7,48.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#CBBE53",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    points: "49.9,27.7 12.2,27.7 12.2,70.3  51.9,70.3 51.9,49  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#B6AA4E",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    points: "48.5,29.4 13.9,29.4 13.9,68.6  49.1,68.6 49.1,49.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#A09648",
    strokeWidth: 0.31,
    strokeMiterlimit: 10,
    points: "47.2,31.1 15.6,31.1 15.6,66.8  46.2,66.8 46.2,50.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#8A8342",
    strokeWidth: 0.26,
    strokeMiterlimit: 10,
    points: "45.8,32.8 17.3,32.8 17.3,65.1  43.4,65.1 43.4,51.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#746F3C",
    strokeWidth: 0.21,
    strokeMiterlimit: 10,
    points: "44.5,34.5 19,34.5 19,63.4 40.6,63.4  40.6,52.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#5E5B36",
    strokeWidth: 0.16,
    strokeMiterlimit: 10,
    points: "43.2,36.2 20.7,36.2 20.7,61.7  37.7,61.7 37.7,52.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#494731",
    strokeWidth: 0.11,
    strokeMiterlimit: 10,
    points: "41.8,37.9 22.3,37.9 22.3,60 34.9,60  34.9,53.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#33342B",
    strokeWidth: 0.06,
    strokeMiterlimit: 10,
    points: "40.5,39.7 24,39.7 24,58.3  32,58.3 32,54.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1D2025",
    strokeWidth: 0.01,
    strokeMiterlimit: 10,
    points: "39.2,41.4 25.7,41.4  25.7,56.6 29.2,56.6 29.2,55.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1D2025",
    points: "55.8,23 31,45.5 26.7,62.9 44.9,59.8 61,45.4 55.5,36.9 41.9,49.9 30.6,55.2 37.2,43 50.7,37.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#F7E55F",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    points: "30.1,60.7 34,47.7 70.1,14.3 79.1,24.1  43.7,57.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#D3C455",
    strokeWidth: 0.42,
    strokeMiterlimit: 10,
    points: "31.7,59.2 35.2,47.7 69.7,15.9  77.5,24.4 43.6,56.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#AEA34C",
    strokeWidth: 0.34,
    strokeMiterlimit: 10,
    points: "33.2,57.7 36.4,47.8 69.2,17.5  75.8,24.7 43.6,55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#8A8342",
    strokeWidth: 0.26,
    strokeMiterlimit: 10,
    points: "34.8,56.2 37.7,47.8 68.7,19.1  74.2,25 43.5,53.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#666238",
    strokeWidth: 0.18,
    strokeMiterlimit: 10,
    points: "36.3,54.8 38.9,47.9 68.3,20.7  72.6,25.3 43.5,52.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#41412F",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    points: "37.9,53.2 40.1,47.9 67.8,22.2  70.9,25.7 43.5,51.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1D2025",
    strokeWidth: 0.01,
    strokeMiterlimit: 10,
    points: "39.5,51.8 41.3,48 67.4,23.8  69.2,26 43.4,50.1  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysiciansResearchManagement);
export default __webpack_public_path__ + "static/media/physiciansResearchManagement.83690db6ce0b6a897611294d0f13f8cb.svg";
export { ForwardRef as ReactComponent };